export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9769.54d131c2.jpg";